module.exports = __webpack_public_path__ + "img/img-0.d098873e.png";